<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="COMMON.TREATMENTS"
    descriptionKey="ADMIN.IA.TREATMENTS.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="treatment?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    @if (loading) {
      <app-admin-state-panel
        mode="loading"
        titleKey="COMMON.LOADING"
      ></app-admin-state-panel>
    } @else if (hasError || !treatment) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.TREATMENTS.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-treatment [payload]="treatment" [showIntro]="false" [onUpdate]="reload"></app-form-treatment>
      </app-admin-form-layout>
    }
  </div>
</section>
